import { UserRegisterDto } from '@interfaces/auth';
import { PlatformUser } from '@interfaces/profile';
import { fetcher } from '@utils/fetcher';

export const register = async (dto: UserRegisterDto): Promise<PlatformUser> =>
  fetcher('/api/auth/register', {
    method: 'POST',
    body: dto,
  });
